import styled from 'styled-components';

interface ContainerProps {
  gap?: number;
  alignItems?: 'center' | 'flex-start' | 'flex-end';
}

export const ViewContainer = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.gap ?? 0}px;
  align-items: ${(props) => props.alignItems ?? 'stretch'};
  flex-shrink: 1;
`;

export const PressableContainer = styled.button<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.gap ?? 0}px;
  align-items: ${(props) => props.alignItems ?? 'stretch'};
  flex-shrink: 1;

  border: none;
  background: none;
  cursor: pointer;
`;
